import CookieStorage from 'core/storage/Cookie';
import { DebugLevel, LogLevel } from 'core/Logger';
const DASH_DEBUG = 'dash_debug';
const DASH_LOG = 'dash_log';
const DEFAULT_EDGE = '1px solid #d3d3d3';
const ACTIVE_EDGE = '1px solid var(--accent)';
export default class Environment {
    static get searchParams() {
        return (typeof URL !== 'undefined' &&
            URL.prototype &&
            URL.prototype.constructor &&
            new URL(window.location.href).searchParams) || { get: () => null };
    }
    static get debugLevel() {
        const debug = this.searchParams.get(DASH_DEBUG) || CookieStorage.get(DASH_DEBUG);
        return debug ?
            DebugLevel[debug] || DebugLevel.NONE :
            DebugLevel.NONE;
    }
    static get logLevel() {
        const log = this.searchParams.get(DASH_LOG) || CookieStorage.get(DASH_LOG);
        return log ?
            LogLevel[log] || LogLevel.ERROR :
            LogLevel.ERROR;
    }
    static get defaultEdge() {
        return DEFAULT_EDGE;
    }
    static get activeEdge() {
        return ACTIVE_EDGE;
    }
}
